// The Work page's CSV export: the items in view, one row each, with the
// columns a client status update needs. Dates stay ISO so a spreadsheet sorts them.
import { toCsv } from '@olytic/foundation';

import { PRIORITY_LABEL, STATUS_LABEL, TYPE_LABEL } from './model';
import type { WorkItem } from './workApi';

const HEADER = ['Key', 'Title', 'Type', 'Status', 'Assignee', 'Priority', 'Due Date', 'Last Modified', 'Epic'];

/** `personName` names a team member by id; a contact assignee carries its own name. */
export function workItemsCsv(items: WorkItem[], personName: (id: string) => string): string {
  const rows = items.map((i) => [
    i.key,
    i.title,
    TYPE_LABEL[i.type],
    STATUS_LABEL[i.status],
    i.assignee_id ? personName(i.assignee_id) : i.assignee_contact?.name ?? '',
    PRIORITY_LABEL[i.priority],
    i.due_date ?? '',
    i.updated_at.slice(0, 10),
    i.type === 'epic' ? '' : i.epic_title ?? '',
  ]);
  return toCsv([HEADER, ...rows]);
}
